import { z } from "zod";
import type { Role } from "./types.js";

import {
  ROLE_DEFAULT_PERMISSIONS, canAreaWith, canWriteEntityWith, hasPermission,
} from "./permissions.js";

// ---------------------------------------------------------------------
// RBAC legado (por papel). Desde a D-27 a fonte de verdade é o catálogo de
// PERMISSÕES (permissions.ts); estas funções seguem existindo para quem só
// tem o papel em mãos e respondem pelo mapa ROLE_DEFAULT_PERMISSIONS — o
// mesmo comportamento de antes da virada.
// ---------------------------------------------------------------------

export type Action = "read" | "create" | "update" | "delete";

export function canAccessArea(role: Role, area: string): boolean {
  return canAreaWith({ role }, area);
}

export function canWriteEntity(role: Role, entity: string): boolean {
  return canWriteEntityWith({ role }, entity);
}

// Leitura: todos os papéis autenticados podem ler entidades (PII é mascarada
// à parte, ver maskPII).
export function canReadEntity(_role: Role, _entity: string): boolean {
  return true;
}

export function canManageUsers(role: Role): boolean {
  return hasPermission({ role }, "usuarios");
}

/**
 * Quem faz TRIAGEM de chamados: vê a fila inteira, muda status, atribui.
 * Por papel: admin e gestor (Diretoria). Por permissão: "chamados.triagem".
 */
export function canTriageIssues(role: Role): boolean {
  return (ROLE_DEFAULT_PERMISSIONS[role] ?? []).includes("chamados.triagem");
}

// ---------------------------------------------------------------------
// Schemas Zod de autenticação (compartilhados front/back).
// ---------------------------------------------------------------------

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const refreshSchema = z.object({
  refreshToken: z.string().min(10),
});

export const createUserSchema = z.object({
  email: z.string().email(),
  name: z.string().min(2),
  password: z.string().min(8),
  role: z.enum(["admin", "torre", "frota", "comercial", "gestor", "motorista"]),
});
export type CreateUserInput = z.infer<typeof createUserSchema>;
